export default "__VITE_ASSET__DOF$71il__"